import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { BootstrapPage } from './BootstrapPage';

interface BootstrapForgotUsernamePageProps {
  location: Location;
}

export const BootstrapForgotUsernamePage = ({ location }: BootstrapForgotUsernamePageProps) => (
  <BootstrapPage flow={FlowType.forgotUsername} location={location} />
);
